import api from "../../api";

function initialState() {
  return {
    news: {
      total: 0,
      fullList: [],
      items: [],
      initial: false
    },
    readArticles: [],
    article: null
  };
}

const newsModule = {
  state: initialState,
  getters: {
    news: state => state.news,
    readArticles: state => state.readArticles,
    article: state => state.article,
    fullList: state => state.fullList
  },
  mutations: {
    SET_NEWS: function(state, news) {
      state.news = news;
    },
    SET_INDIVIDUAL_NEWS: function(state, news) {
      state.article = news;
    },
    REMOVE_ARTICLE: function(state) {
      state.article = null;
    },
    SET_ARTICLE_READ: function(state, article) {
      if (!state.readArticles.find(a => a === article)) {
        state.readArticles = [...state.readArticles, article];
      }
    },
    RESET_NEWS: function(state) {
      const s = initialState();
      Object.keys(s).forEach(key => {
        state[key] = s[key];
      });
    }
  },
  actions: {
    getNews: function({ commit }, settings) {
      if (!this.getters.isLoading && !settings.hideSpinner) {
        commit("SET_IS_LOADING", true);
      }
      return api.news
        .getNews(settings.page, this.getters.appFilters, settings.itemsPerPage)
        .then(response => {
          commit("SET_NEWS", response);
        })
        .finally(() => {
          if (this.getters.isLoading) {
            commit("SET_IS_LOADING", false);
            this.dispatch("getSchoolStatus");
          }
        });
    },
    getIndividualNews: function({ commit, state }, id) {
      return new Promise(resolve => {
        const article = state.news.items.find(article => article.id === id);
        if (article) {
          commit("SET_INDIVIDUAL_NEWS", article);
          resolve();
        } else {
          if (!this.getters.isLoading) {
            commit("SET_IS_LOADING", true);
          }
          api.news
            .getIndividualNews(id)
            .then(response => {
              commit("SET_INDIVIDUAL_NEWS", response);
            })
            .finally(() => {
              if (this.getters.isLoading) {
                commit("SET_IS_LOADING", false);
              }
              resolve();
            });
        }
      });
    },
    removeArticle: function({ commit }) {
      commit("REMOVE_ARTICLE");
    },
    setArticleRead: function({ commit }, id) {
      commit("SET_ARTICLE_READ", id);
    }
  }
};
export default newsModule;
